import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import style from './contact-info-field.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children - Content to display next to the icon
 * @param {import('@fortawesome/fontawesome-common-types').IconDefinition} props.icon - FontAwesome icon definition (e.g., faEnvelope)
 * @returns {JSX.Element}
 */
export const ContactInfoField = ({ children, icon }) => {
  return (
    <div className={style['contact-info-field-container']}>
      <FontAwesomeIcon className={style['contact-info-field-icon']} icon={icon} />
      {children}
    </div>
  );
};
